var map = {
	"./icon-academic-cap.png": 99824,
	"./icon-adjustments-horizontal.png": 42039,
	"./icon-adjustments-vertical.png": 37881,
	"./icon-archive-box-arrow-down.png": 92596,
	"./icon-archive-box-x-mark.png": 34588,
	"./icon-archive-box.png": 69770,
	"./icon-arrow-down-circle.png": 1661,
	"./icon-arrow-down-left.png": 86204,
	"./icon-arrow-down-on-square-stack.png": 8543,
	"./icon-arrow-down-on-square.png": 98189,
	"./icon-arrow-down-right.png": 58342,
	"./icon-arrow-down-tray.png": 72225,
	"./icon-arrow-down.png": 1409,
	"./icon-arrow-left-circle.png": 59701,
	"./icon-arrow-left-on-rectangle.png": 85234,
	"./icon-arrow-left.png": 44068,
	"./icon-arrow-long-down.png": 59710,
	"./icon-arrow-long-left.png": 83256,
	"./icon-arrow-long-right.png": 19107,
	"./icon-arrow-long-up.png": 47719,
	"./icon-arrow-path-rounded-square.png": 90387,
	"./icon-arrow-path.png": 32825,
	"./icon-arrow-right-circle.png": 615,
	"./icon-arrow-right-on-rectangle.png": 60379,
	"./icon-arrow-right.png": 88368,
	"./icon-arrow-small-down.png": 90675,
	"./icon-arrow-small-left.png": 12932,
	"./icon-arrow-small-right.png": 39376,
	"./icon-arrow-small-up.png": 30163,
	"./icon-arrow-top-right-on-square.png": 23755,
	"./icon-arrow-trending-down.png": 41993,
	"./icon-arrow-trending-up.png": 35443,
	"./icon-arrow-up-circle.png": 67883,
	"./icon-arrow-up-left.png": 90977,
	"./icon-arrow-up-on-square-stack.png": 56752,
	"./icon-arrow-up-on-square.png": 3170,
	"./icon-arrow-up-right.png": 42930,
	"./icon-arrow-up-tray.png": 42114,
	"./icon-arrow-up.png": 55295,
	"./icon-arrow-uturn-down.png": 26216,
	"./icon-arrow-uturn-left.png": 68260,
	"./icon-arrow-uturn-right.png": 85916,
	"./icon-arrow-uturn-up.png": 45693,
	"./icon-arrows-pointing-in.png": 17791,
	"./icon-arrows-pointing-out.png": 94732,
	"./icon-arrows-right-left.png": 79059,
	"./icon-arrows-up-down.png": 26666,
	"./icon-at-symbol.png": 77181,
	"./icon-backspace.png": 48764,
	"./icon-backward.png": 34142,
	"./icon-banknotes.png": 62507,
	"./icon-bars-2.png": 1337,
	"./icon-bars-3-bottom-left.png": 85551,
	"./icon-bars-3-bottom-right.png": 2025,
	"./icon-bars-3-center-left.png": 67786,
	"./icon-bars-3.png": 58105,
	"./icon-bars-4.png": 24147,
	"./icon-bars-arrow-down.png": 91825,
	"./icon-bars-arrow-up.png": 64782,
	"./icon-battery-0.png": 53221,
	"./icon-battery-100.png": 86220,
	"./icon-battery-50.png": 7859,
	"./icon-beaker.png": 72952,
	"./icon-bell-alert.png": 72092,
	"./icon-bell-slash.png": 67530,
	"./icon-bell-snooze.png": 39174,
	"./icon-bell.png": 46825,
	"./icon-bolt-slash.png": 124,
	"./icon-bolt.png": 27021,
	"./icon-book-open.png": 68349,
	"./icon-bookmark-slash.png": 22064,
	"./icon-bookmark-square.png": 19392,
	"./icon-bookmark.png": 56138,
	"./icon-briefcase.png": 73301,
	"./icon-bug-ant.png": 32328,
	"./icon-building-library.png": 61925,
	"./icon-building-office-2.png": 13830,
	"./icon-building-office.png": 66281,
	"./icon-building-storefront.png": 89982,
	"./icon-cake.png": 79289,
	"./icon-calculator.png": 2698,
	"./icon-calendar-days.png": 23544,
	"./icon-calendar.png": 1236,
	"./icon-camera.png": 88167,
	"./icon-chart-bar-square.png": 67172,
	"./icon-chart-bar.png": 83440,
	"./icon-chart-pie.png": 19475,
	"./icon-chat-bubble-bottom-center-text.png": 79690,
	"./icon-chat-bubble-bottom-center.png": 87788,
	"./icon-chat-bubble-left-ellipsis.png": 99253,
	"./icon-chat-bubble-left-right.png": 57319,
	"./icon-chat-bubble-left.png": 85791,
	"./icon-chat-bubble-oval-left-ellipsis.png": 89219,
	"./icon-chat-bubble-oval-left.png": 32265,
	"./icon-check-badge.png": 46584,
	"./icon-check-circle.png": 80162,
	"./icon-check.png": 72985,
	"./icon-chevron-double-down.png": 45981,
	"./icon-chevron-double-left.png": 58410,
	"./icon-chevron-double-right.png": 3712,
	"./icon-chevron-double-up.png": 56292,
	"./icon-chevron-down.png": 66957,
	"./icon-chevron-left.png": 75928,
	"./icon-chevron-right.png": 29751,
	"./icon-chevron-up-down.png": 48477,
	"./icon-chevron-up.png": 25101,
	"./icon-circle-stack.png": 19285,
	"./icon-clipboard-document-check.png": 62721,
	"./icon-clipboard-document-list.png": 75841,
	"./icon-clipboard-document.png": 4335,
	"./icon-clipboard.png": 359,
	"./icon-clock.png": 983,
	"./icon-cloud-arrow-down.png": 23585,
	"./icon-cloud-arrow-up.png": 30221,
	"./icon-cloud.png": 45427,
	"./icon-code-bracket-square.png": 183,
	"./icon-code-bracket.png": 49467,
	"./icon-cog-6-tooth.png": 62861,
	"./icon-cog-8-tooth.png": 82535,
	"./icon-cog.png": 16382,
	"./icon-command-line.png": 94537,
	"./icon-computer-desktop.png": 73160,
	"./icon-cpu-chip.png": 419,
	"./icon-credit-card.png": 11629,
	"./icon-cube-transparent.png": 42489,
	"./icon-cube.png": 80830,
	"./icon-currency-bangladeshi.png": 99331,
	"./icon-currency-dollar.png": 9708,
	"./icon-currency-euro.png": 61359,
	"./icon-currency-pound.png": 24599,
	"./icon-currency-rupee.png": 96106,
	"./icon-currency-yen.png": 56288,
	"./icon-cursor-arrow-rays.png": 34921,
	"./icon-cursor-arrow-ripple.png": 60756,
	"./icon-device-phone-mobile.png": 51664,
	"./icon-device-tablet.png": 75360,
	"./icon-document-arrow-down.png": 82863,
	"./icon-document-arrow-up.png": 91712,
	"./icon-document-chart-bar.png": 14613,
	"./icon-document-check.png": 75983,
	"./icon-document-duplicate.png": 45087,
	"./icon-document-magnifying-glass.png": 49769,
	"./icon-document-minus.png": 94725,
	"./icon-document-plus.png": 22033,
	"./icon-document-text.png": 92834,
	"./icon-document.png": 98982,
	"./icon-ellipsis-horizontal-circle.png": 89799,
	"./icon-ellipsis-horizontal.png": 38516,
	"./icon-ellipsis-vertical.png": 4001,
	"./icon-envelope-open.png": 39379,
	"./icon-envelope.png": 26309,
	"./icon-exclamation-circle.png": 79813,
	"./icon-exclamation-triangle.png": 77696,
	"./icon-eye-dropper.png": 26982,
	"./icon-eye-slash.png": 86765,
	"./icon-eye.png": 41286,
	"./icon-face-frown.png": 17687,
	"./icon-face-smile.png": 10956,
	"./icon-film.png": 94892,
	"./icon-finger-print.png": 79146,
	"./icon-fire.png": 5692,
	"./icon-flag.png": 55743,
	"./icon-folder-arrow-down.png": 46314,
	"./icon-folder-minus.png": 58206,
	"./icon-folder-open.png": 15405,
	"./icon-folder-plus.png": 37714,
	"./icon-folder.png": 90062,
	"./icon-forward.png": 4233,
	"./icon-funnel.png": 41454,
	"./icon-gif.png": 48007,
	"./icon-gift-top.png": 79361,
	"./icon-gift.png": 62970,
	"./icon-globe-alt.png": 18234,
	"./icon-globe-americas.png": 32420,
	"./icon-globe-asia-australia.png": 18554,
	"./icon-globe-europe-africa.png": 10238,
	"./icon-hand-raised.png": 63792,
	"./icon-hand-thumb-down.png": 74578,
	"./icon-hand-thumb-up.png": 79502,
	"./icon-hashtag.png": 83693,
	"./icon-heart.png": 89374,
	"./icon-home-modern.png": 8837,
	"./icon-home.png": 35529,
	"./icon-identification.png": 5970,
	"./icon-inbox-arrow-down.png": 96942,
	"./icon-inbox-stack.png": 25184,
	"./icon-inbox.png": 73135,
	"./icon-information-circle.png": 85835,
	"./icon-key.png": 10782,
	"./icon-language.png": 68144,
	"./icon-lifebuoy.png": 11002,
	"./icon-light-bulb.png": 74824,
	"./icon-link.png": 95280,
	"./icon-list-bullet.png": 55773,
	"./icon-lock-closed.png": 75713,
	"./icon-lock-open.png": 45385,
	"./icon-magnifying-glass-circle.png": 33849,
	"./icon-magnifying-glass-minus.png": 37489,
	"./icon-magnifying-glass-plus.png": 79942,
	"./icon-magnifying-glass.png": 71904,
	"./icon-map-pin.png": 16185,
	"./icon-map.png": 37513,
	"./icon-megaphone.png": 1013,
	"./icon-microphone.png": 28447,
	"./icon-minus-circle.png": 66575,
	"./icon-minus-small.png": 36677,
	"./icon-minus.png": 53272,
	"./icon-moon.png": 41566,
	"./icon-musical-note.png": 4579,
	"./icon-newspaper.png": 6367,
	"./icon-no-symbol.png": 48035,
	"./icon-paint-brush.png": 79971,
	"./icon-paper-airplane.png": 55613,
	"./icon-paper-clip.png": 88770,
	"./icon-pause-circle.png": 50378,
	"./icon-pause.png": 63637,
	"./icon-pencil-square.png": 13985,
	"./icon-pencil.png": 13062,
	"./icon-phone-arrow-down-left.png": 48011,
	"./icon-phone-arrow-up-right.png": 30250,
	"./icon-phone-x-mark.png": 66801,
	"./icon-phone.png": 10366,
	"./icon-photo.png": 8006,
	"./icon-play-circle.png": 70938,
	"./icon-play-pause.png": 441,
	"./icon-play.png": 47790,
	"./icon-plus-circle.png": 1993,
	"./icon-plus-small.png": 3996,
	"./icon-plus.png": 13482,
	"./icon-power.png": 7162,
	"./icon-presentation-chart-bar.png": 43094,
	"./icon-presentation-chart-line.png": 42051,
	"./icon-printer.png": 86612,
	"./icon-puzzle-piece.png": 65150,
	"./icon-qr-code.png": 4118,
	"./icon-question-mark-circle.png": 91429,
	"./icon-queue-list.png": 9241,
	"./icon-radio.png": 84507,
	"./icon-receipt-percent.png": 50963,
	"./icon-receipt-refund.png": 70442,
	"./icon-rectangle-group.png": 2079,
	"./icon-rectangle-stack.png": 74353,
	"./icon-rocket-launch.png": 6483,
	"./icon-rss.png": 14523,
	"./icon-scale.png": 76914,
	"./icon-scissors.png": 75486,
	"./icon-server-stack.png": 34364,
	"./icon-server.png": 24916,
	"./icon-share.png": 84586,
	"./icon-shield-check.png": 549,
	"./icon-shield-exclamation.png": 92339,
	"./icon-shopping-bag.png": 67679,
	"./icon-shopping-cart.png": 90400,
	"./icon-signal-slash.png": 31328,
	"./icon-signal.png": 51195,
	"./icon-sparkles.png": 86718,
	"./icon-speaker-wave.png": 44814,
	"./icon-speaker-x-mark.png": 5265,
	"./icon-square-2-stack.png": 60406,
	"./icon-square-3-stack-3d.png": 17510,
	"./icon-squares-2x2.png": 90990,
	"./icon-squares-plus.png": 41626,
	"./icon-star.png": 25092,
	"./icon-stop-circle.png": 15132,
	"./icon-stop.png": 9967,
	"./icon-sun.png": 52153,
	"./icon-swatch.png": 18231,
	"./icon-table-cells.png": 44810,
	"./icon-tag.png": 98701,
	"./icon-ticket.png": 58273,
	"./icon-trash.png": 16238,
	"./icon-trophy.png": 99689,
	"./icon-truck.png": 82367,
	"./icon-tv.png": 44786,
	"./icon-user-circle.png": 53025,
	"./icon-user-group.png": 72879,
	"./icon-user-minus.png": 27231,
	"./icon-user-plus.png": 81195,
	"./icon-user.png": 34377,
	"./icon-users.png": 4809,
	"./icon-variable.png": 18140,
	"./icon-video-camera-slash.png": 44811,
	"./icon-video-camera.png": 96618,
	"./icon-view-columns.png": 98904,
	"./icon-viewfinder-circle.png": 93069,
	"./icon-wallet.png": 22794,
	"./icon-wifi.png": 94025,
	"./icon-window.png": 4624,
	"./icon-wrench-screwdriver.png": 89344,
	"./icon-wrench.png": 19880,
	"./icon-x-circle.png": 23876,
	"./icon-x-mark.png": 46085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49097;